module.exports = __webpack_public_path__ + "static/media/community@3x.6fe2e137.png";